import React from 'react';
import { classnames } from 'Utils/classnames';
import PropTypes from 'prop-types';
import { nameMap } from './nameMap';
import ProjectConfig from 'ProjectConfig';

const { version } = ProjectConfig;

const Icon = props => {

  const { iconName, className = '', title = '', id = '', style = {}, svgViewBox } = props;

  const componentClasses = classnames({
    icon: true,
    [nameMap[iconName]]: true
  });

  const iconSvg = iconName && iconName.substring(0, 3) === 'svg' ? (
    <svg
      viewBox={ svgViewBox }
      preserveAspectRatio={ svgViewBox ? 'xMidYMid meet' : undefined }
    >
      <use xlinkHref={ `/static/images/icons.${ version }.svg#${nameMap[iconName]}` } />
    </svg>
  ) : null;

  return (
    <i id={ id } className={ `${componentClasses} ${className}` } onClick={ props.onClick || null } title={ title } style={ style }>
      { iconSvg }
    </i>
  );
};

Icon.propTypes = {

  /** Icon name (You can find full list of icon names from nameMap.js)  */
  //TODO: iconName: PropTypes.string.isRequired haline geri çevirirsek BE'den gelmediği sürece hata veriyor.
  iconName: PropTypes.string,

  /** You can pass extra classes  */
  className: PropTypes.string,

  /** You can pass onClick event */
  onClick: PropTypes.func,

  title: PropTypes.string,
  id: PropTypes.string,

  /** You can pass inline styles */
  style: PropTypes.object,

  svgViewBox: PropTypes.string
};

export default Icon;
